import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

const Throbber = ({
  hidden,
  loadingText,
  alignRight,
  alignLeft,
  relative
}) => (
  <div className={cx('throbber__fluid', {
    'sr-only': hidden,
    'throbber__fluid--right': alignRight,
    'throbber__fluid--left': alignLeft,
    'throbber__fluid--relative': relative
  })}>
    <div>
      <p className="full-width center-align">
        {loadingText}
      </p>
      <div className="throbber__rotate throbber__rotate--black" />
    </div>
  </div>
);

Throbber.propTypes = {
  hidden: PropTypes.bool,
  loadingText: PropTypes.string.isRequired,
  alignRight: PropTypes.bool,
  alignLeft: PropTypes.bool,
  relative: PropTypes.bool
}

export default Throbber;